import React, {Component} from 'react';

import Card from './Card';
import Pagination from './Pagination';

/** ThreadList expects an Array of data in a JSON format
    and displays a list of Reddit threads in a card format.  */
class ThreadList extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      firstItem: '',
      lastItem: '',
    };
  }

  /**
   * Assigns the first and last item in the array and binds it to state.
   * This occurs whenever the list updates and gets handed off to the Pagination component
   * so it knows where to place the next/previous button points.
   * @param {object} nextProps - The next props that the component will receieve on update.
   * @returns {undefined}
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.threads.length) {
      const lastItem = nextProps.threads.slice(-1).pop().data.id;
      const firstItem = nextProps.threads[0].data.id;

      if (
        this.state.firstItem !== firstItem ||
        this.state.lastItem !== lastItem
      ) {
        this.setState({
          firstItem,
          lastItem,
        });
      }
    }
  }

  /**
   * Loops over each Reddit 'thread' and maps it to the props of the Card component.
   * This allows each component to maintain its own level of state for expandable content.
   * If there's an error fetching (such as a lack of content) it gets returned instead.
   * @returns {string} JSX representing either the content card or an error.
   */
  renderThread() {
    if (this.props.threads.length) {
      return this.props.threads.map((thread, index) => {
        return <Card key={thread.data.id} thread={thread} index={index} />;
      });
    } else {
      return (
        <div className="progress-container col s12">{this.renderError()}</div>
      );
    }
  }

  /**
   * Renders either the error, or a loading/progress bar.
   * @returns {string} JSX representing a loading bar or an error.
   */
  renderError() {
    if (this.props.toast.length) {
      return (
        <div>
          <h4>{this.props.toast}</h4>
        </div>
      );
    } else {
      return (
        <div className="progress">
          <div className="indeterminate" />
        </div>
      );
    }
  }

  /**
   * Renders the Thread List component.
   * @returns {string} JSX representation of the component.
   */
  render() {
    return (
      <div>
        {this.renderThread()}

        {!this.props.toast && (
          <Pagination
            lastItem={this.state.lastItem}
            firstItem={this.state.firstItem}
            location={this.props.location}
            params={this.props.params}
          />
        )}
      </div>
    );
  }
}

export default ThreadList;



// WEBPACK FOOTER //
// ./src/components/ThreadList.js